import "./App.css";
import { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import About from "./components/AboutUs/About";
import Grapes from "./Grapes";
import { Team } from "./components/Team/Team";
import { BoardMembers } from "./components/BordMember/BoardMembers";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import MainDashboard from "./components/dashBoard/MainDashboard";
import ServiceCards from "./components/ServicesCards/ServiceCads";
import Iss from "./components/ISS/Iss";
import SundarMap from "./components/SundarMap/SundarMap";
import UserDashboaard from "./components/UserDashboard/UserDashboaard";
function App() {
  const [posts, setposts] = useState([]);
  useEffect(() => getData(), []);

  const getData = () => {
    fetch("https://jsonplaceholder.typicode.com/todos/")
      .then((response) => response.json())
      .then((json) => setposts(json))
      .catch((err) => console.log(err));
  };

  //axios.get('https://jsonplaceholder.typicode.com/todos/')

  return (
    <div className="App">
      <Routes>
        <Route path="/Grapes" element={<Grapes />} />
        <Route path="/About" element={<About />} />
        <Route path="/Team" element={<Team />} />
        <Route path="/BoardMembers" element={<BoardMembers />} />
        <Route path="/Services" element={<ServiceCards />} />
        <Route path="/Home" element={<MainDashboard />} />
        <Route path="" element={<MainDashboard />} />
        <Route path="/Iss" element={<Iss />} />
        <Route path="/Location" element={<SundarMap />} />
        <Route path="/UserDashboard" element={<UserDashboaard />} />
      </Routes>
    </div>
  );
}

export default App;
